import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { Helmet } from '../../../../components/Helmet';
import { RecruiterProfileForm } from '../../components/ProfileForm';
import { profileActions } from '../../redux/slice/profileSlice';

export const Profile = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { referrer } = useAppSelector((state) => state.app);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        dispatch(profileActions.getProfileData());

        return function () {
            dispatch(profileActions.clearData());
        };
    }, []);

    const onBackClick = useCallback(() => {
        if (location.state?.from?.pathname) {
            navigate(location.state?.from?.pathname);
            return;
        }
        if (referrer) {
            window.location.href = referrer;
            return;
        }
    }, [referrer, location]);

    return (
        <>
            <Helmet pageName={__t('Профиль')} />
            <div className='recruiter-profile-page'>
                <Header title={__t('Профиль')} onBackClick={onBackClick} />
                <RecruiterProfileForm />
            </div>
        </>
    );
};
